var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function CalculatorModule() {
  this.init();
}

CalculatorModule.prototype = new Base();

CalculatorModule.prototype.init = function() {
  var $calculator = $('[data-calculator]');
  if ($calculator.get(0) !== undefined) {
    ko.applyBindings(
      new model({ element: $calculator.data('calculator') }),
      $calculator.get(0)
    );
  }
};

module.exports = CalculatorModule;
